import {Grid} from "@mui/system";

import {DefaultCardStructure} from "components";
import {useFormContext, useWatch} from "react-hook-form";
import useHandleBoardingFields from "views/ProcessDetails/refactor/useHandleBoardingFields";
import pxToRem from "hooks/usePxToRem";
import {memo} from "react";

import {VoyageToSend} from "views/ProcessDetails/refactor/types/voyages.types";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {
  VoyagesV2,
  CCTInfo,
  Voyages,
} from "views/ProcessDetails/refactor/components/ProcessBoarding/components";

type Props = {
  addNewVoyage: (
    id: number,
    voyages: Partial<VoyageToSend> | Partial<VoyageToSend>[],
  ) => Promise<Process | undefined>;
  refetchProcess: () => Promise<Process | undefined>;
};

const ProcessBoarding = (props: Props) => {
  const {fclCase, mainCase, airImportMainCase} = useHandleBoardingFields();
  const typeLoadOfFirstProcessLoad = useWatch({
    name: "processLoads.0.typeLoad",
  });
  const {getValues} = useFormContext<Process>();
  const isAiProcess =
    `${getValues("operation")?.[0]}${getValues("modality")?.[0]}` === "IA";

  const caseToRender = () => {
    if (isAiProcess) {
      return airImportMainCase;
    }
    return typeLoadOfFirstProcessLoad === "FCL" ? fclCase : mainCase;
  };

  return (
    <DefaultCardStructure linkId="boarding" title="Embarque" hasDivider={true}>
      <Grid container columnSpacing={pxToRem(8)} rowSpacing={pxToRem(20)}>
        {caseToRender().map((item) => {
          const {item: Component, id, ...props} = item;
          return <Component key={id} {...props} />;
        })}
        {isAiProcess && <CCTInfo />}
        {Boolean(import.meta.env.VITE_ENABLE_NEW_VOYAGE_LAYOUT) && (
          <VoyagesV2
            addNewVoyage={props.addNewVoyage}
            refetchProcess={props.refetchProcess}
          />
        )}
        {!import.meta.env.VITE_ENABLE_NEW_VOYAGE_LAYOUT && (
          <Voyages
            addNewVoyage={props.addNewVoyage}
            refetchProcess={props.refetchProcess}
          />
        )}
      </Grid>
    </DefaultCardStructure>
  );
};

export default memo(ProcessBoarding);
